import { render, staticRenderFns } from "./u-textarea-filled-rounded.vue?vue&type=template&id=cb9ced50&scoped=true"
import script from "./u-textarea-filled-rounded.vue?vue&type=script&lang=js"
export * from "./u-textarea-filled-rounded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9ced50",
  null
  
)

export default component.exports